export default __webpack_public_path__ + "static/media/plain-sticker-f.2f9b709b.png";